import React, { useMemo } from "react";
import styled from "styled-components";
import { Wrapper } from "../styles";
import { CustomDivider } from "../styles/Main.styled";

import orderIcon from "../../assets/images/how_it_works/icon_order.svg";
import translateIcon from "../../assets/images/how_it_works/icon_translate.svg";
import deliveryIcon from "../../assets/images/how_it_works/icon_delivery.svg";
import printIcon from "../../assets/images/how_it_works/icon_print.svg";
import archVector from "../../assets/images/how_it_works/arch-vector.svg";
import { theme } from "../../style";
import { useMediaQuery } from "react-responsive";


const WorksContainer = styled.div`
position: relative;
width: 25%;
@media (max-width: 768px) {
    width: 100%;
}
`;


const WorksCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem;
  text-align: center;
  border: 1px solid;
  border-image-slice: 1;
  border-width: 1px;
  border-image-source: linear-gradient(to bottom, #012f6b, #f49924);
  height: 25vh;
  @media (max-width: 768px) {
    margin: 1rem;
  }
`;

const CardIcon = styled.img`
  width: 52px;
  height: 52px;
  margin-bottom: 20px;
`;
const CardTitle = styled.h4`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
    color: background: rgba(40, 35, 35, 0.8);
    `;
const CardDescription = styled.p`
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 20px;
    color:background: rgba(40, 35, 35, 0.7);
    `;
const ArchContainer = styled.div`
  position: absolute;
  width: 100%;

  ${({ relation }) =>
        relation === "bottom"
            ? `
    bottom: -40%;
    left: 50%;
    transform: rotate(180deg);`
            : `
        top: -40%;
        left: 50%;
        `}
`;
const ArchVector = styled.img`
  width: 100%;
  position: relative;
`;
const ArchMark = styled.span`
  font-size: 12px;
  color: #fff;
  font-weight: bold;
  background-color: ${theme.colors.secondary};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => props?.relation === "bottom" && "transform : rotate(180deg);"}
  ${({ step }) => step === 1 && `
    position: absolute;
    right: 0px;
    top: 0px;
  ` }
`;

const Arch = ({
    relation,
    steps = [1],
}: {
    relation: string,
    steps: string[],
}) => {
    return (
        <ArchContainer relation={relation}>
            <ArchVector src={archVector} />
            <div
                style={{
                    position: "absolute",
                    height: "60%",
                    width: "100%",
                    bottom: 0,
                    left: 0,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }}
            >
                {steps &&
                    steps.map((e) => <ArchMark relation={relation} step={e}>{e}</ArchMark>)}
            </div>
        </ArchContainer>
    );
};




const HowItWorks = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const data = useMemo(
        () => [
            {
                id: 1,
                title: "Order",
                description: "request the type of translation you want",
                icon: orderIcon,
                relation: "bottom",
                steps: [1],
            },
            {
                id: 2,
                title: "Translate",
                description: "Request the type of translation you want",
                icon: translateIcon,
                relation: "top",
                steps: [2, 3],
            },
            {
                id: 3,
                title: "Check",
                description: "Request the type of translation you want",
                icon: deliveryIcon,
                relation: "bottom",
                steps: [4],
            },
            {
                id: 4,
                title: "Deliver",
                description: "Request the type of translation you want",
                icon: printIcon,
            },
        ],
        []
    );
    return (
        <Wrapper type="container" isSection>
            <Wrapper>
                <h3>How it works</h3>
                <CustomDivider />
            </Wrapper>

            <Wrapper isSection hasColumns spaceStyle="space-evenly">
                {data.map(({ id, title, description, icon, relation, steps }) => (
                    <>
                        <WorksContainer>
                            <WorksCard key={`${id} ${title} ${description} `}>
                                <CardIcon src={icon} alt="icon" />
                                <CardTitle>{title}</CardTitle>
                                <CardDescription>{description}</CardDescription>
                            </WorksCard>
                            {relation && !isMobile && <Arch steps={steps} relation={relation} />}
                        </WorksContainer>
                    </>
                ))}
            </Wrapper>
        </Wrapper>
    );
};

export default HowItWorks;
